<template>
    <label :for="forId" class="form-label">
        <slot></slot>
    </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        forId: { type: String, required: true }
    }
});
</script>